<av-card class="calendar" [backdrop]="false">
  <div class="calendar-header">
    {{ appointment().start | dayjsFormat : "MMMM" : lang() }}
  </div>
  <av-card-body size="md" type="container">
    <div class="fx-column fx-gap-sm fx-align-center">
      <div>
        {{ appointment().start | dayjsFormat : "dddd" : lang() }}
      </div>
      <h1>
        {{ appointment().start | dayjsFormat : "DD" : lang() }}
      </h1>
      <div class="fx-column fx-gap-xs fx-align-center">
        <h4>
          {{ appointment().start | dayjsFormat : "HH:mm" : lang() }}
        </h4>
        <small class="text-muted">({{ timezoneOffset() }})</small>
      </div>
    </div>
  </av-card-body>
</av-card>
